(function () {
  function init() {
    var root = document.getElementById('lp-bars');
    if (!root || root.dataset.bound === '1') return;
    root.dataset.bound = '1';

    var list = root.querySelector('#lp-bars-list');
    var tabs = root.querySelectorAll('.lp-bars-tab');
    if (!list || !tabs.length) return;

    var gateways = [
      { name: 'plata by mono', sub: 'monobank · 1,3% UA', basic: 4.05, advanced: 2.65, custom: 2.65 },
      { name: 'Hutko',          sub: 'ПУМБ · 1,5%',       basic: 4.25, advanced: 2.85, custom: 2.85 },
      { name: 'WayForPay',      sub: 'WayForPay · 2,0%',  basic: 4.75, advanced: 3.35, custom: 2.85 },
      { name: 'LiqPay',         sub: 'ПриватБанк · 2,75%',basic: 5.50, advanced: 4.10, custom: 2.85 }
    ];

    var maxRate = 6;

    function render(scenario) {
      var html = '';
      var sorted = gateways.slice().sort(function (a, b) {
        return a[scenario] - b[scenario];
      });
      sorted.forEach(function (g) {
        var rate = g[scenario];
        var width = (rate / maxRate) * 100;
        var hl = g.name === 'LiqPay' ? 'highlight' : '';
        html += '<div class="lp-bar-row ' + hl + '">' +
                  '<div class="lp-bar-name">' + g.name + '<small>' + g.sub + '</small></div>' +
                  '<div class="lp-bar-track"><div class="lp-bar-fill" style="width:' + width + '%"></div></div>' +
                  '<div class="lp-bar-val">' + rate.toFixed(2).replace('.', ',') + ' %</div>' +
                '</div>';
      });
      list.innerHTML = html;
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        tabs.forEach(function (t) { t.classList.remove('active'); });
        tab.classList.add('active');
        render(tab.getAttribute('data-scenario'));
      });
    });

    render('basic');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
